export default __webpack_public_path__ + "static/media/membership.57b2d8f4.jpg";